import {Base} from "@/api/Base"

export class AnnualLeavePlanListAll extends Base {
    path = "annualLeavePlan/listAll"
}